import { Component, Prop, Mixins } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';
import CalendarDetail, { Props } from '../detail';
import { DAYS_OF_WEEK } from '../const';
import CalendarHead from '../head';

@Component({
  components: {
    CalendarDetail,
    CalendarHead,
  }
})
export default class CalendarDay extends Mixins(Props) {
  // Props
  @Prop({ type: Object, default: null})
  next: RawLocation;

  @Prop({ type: Object, default: null})
  prev: RawLocation;

  @Prop({ type: Boolean, default: false })
  completed: boolean;

  // Computed
  get day() {
    const day = this.value.getDay() - 1;
    return DAYS_OF_WEEK[day < 0 ? 6 : day];
  }
}



// WEBPACK FOOTER //
// ./src/components/calendar/day/script.ts